var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbhaIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 16.4375L10.9375 5.625M10.9375 5.625L9.375 3.125H7.8125H3.125C2.4375 3.125 1.875 3.6875 1.875 4.375V15.625C1.875 16.3125 2.4375 16.875 3.125 16.875H16.875C17.5625 16.875 18.125 16.3125 18.125 15.625V6.875C18.125 6.1875 17.5625 5.625 16.875 5.625H10.9375Z",
    stroke: "#192852",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 8.75H8.75",
    stroke: "#192852",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 11.25H6.875",
    stroke: "#192852",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbhaIcon5);
export default __webpack_public_path__ + "static/media/abha-icon5.af8bd50462462fa3d5a03ef020ed4f0d.svg";
export { ForwardRef as ReactComponent };